export default [
    { key: 'external_sync_offers', label: 'Offers sync' },
    { key: 'import_offers', label: 'Import offers' },
    { key: 'event_status_change', label: 'Bulk rejection of events' },
    { key: 'event_adjust_mass', label: 'Manual adjustment' },
    { key: 'external_import_offers', label: 'Import offers (external)' },
];
